module.exports = __webpack_public_path__ + "static/media/sketches-by-lucastswick-11.6dcfbb29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sketches/sketches-by-lucastswick-11.jpg
// module id = 4380
// module chunks = 13